import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ApiService } from "../services/api.service";
import { Observable } from 'rxjs';


@Injectable()
export class FrontendGuard implements CanActivate {
    constructor(private router: Router) { }

    canActivate(): boolean
    {
        const canActivate = !!ApiService.readToken();
        if(!canActivate)
        {
            alert('Geen toegang');
            this.router.navigate(['/']);
        }

        return canActivate;
    }
}


// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/frontend.guard.ts